module.exports = __webpack_public_path__ + "img/pin-field.183b177c.svg";